import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class InsReportSrcQueryService {

  public GET_INS_REPORT_DATA: any;

  constructor(public apollo: Apollo) {

    // Get report from inspection report
    this.GET_INS_REPORT_DATA =
      gql`     
          query GetReturnSelectedId($insReportId:String!) {                           
          allInspectionReportsSrcs(condition:{insReportId:$insReportId})  {
            edges {
              node {
                insReportId   
                nodeId
                alterEmail            
              }
            }
          }  
        }
      `;
  }

  /** GET INSPECTION REPORT DATA */
  GET_INS_REPORT(): any {

    return this.apollo
      .watchQuery({
        query: this.GET_INS_REPORT_DATA,
        variables:
        {
          'insReportId': window.localStorage.getItem('reportId').trim(),
        },
        fetchPolicy: 'network-only'
      });
  }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/gql-query-mutation/ins-report-src.service.ts